import { useSelector } from 'react-redux'
import { Tag } from 'antd'
import { DFM_SOURCE_TYPE_3D } from '@Admin/AdminQuotingPage/constants'

import { getToolVisibility } from '~/redux-modules/qmr-viewer/selectors'

const TAG_STYLE = { cursor: 'pointer' }

interface CheckableTagPropsType {
    checked: boolean
    children: string
    toggleFunction: () => void
}

// the antd CheckableTag doesn't put a box around the unchecked version
// so it's not very nice
// so this provides the same API but looks how we want it
const CheckableTag = (props: CheckableTagPropsType) => {
    const { checked, children, toggleFunction } = props

    if (checked) {
        return (
            <Tag
                color="success"
                data-test-target="transparent-mode-3d-viewer"
                onClick={toggleFunction}
                style={TAG_STYLE}
            >
                {children}
            </Tag>
        )
    }

    return (
        <Tag
            data-test-target="transparent-mode-3d-viewer"
            onClick={toggleFunction}
            style={TAG_STYLE}
        >
            {children}
        </Tag>
    )
}

interface InfoBarPropsType {
    dimensions?: string
    onReset: () => void
    onToggleTransparent: () => void
    sourceType?: string | null
    transparentMode: boolean
}

const InfoBar = (props: InfoBarPropsType) => {
    const {
        dimensions,
        onReset,
        onToggleTransparent,
        sourceType,
        transparentMode,
    } = props

    const toolVisibility = useSelector(getToolVisibility)

    if (!toolVisibility?.infoBar) {
        return null
    }

    const resetTagText =
        sourceType === DFM_SOURCE_TYPE_3D ? 'reset view' : 'reset camera '

    return (
        <div
            style={{
                bottom: 0,
                padding: '8px',
                position: 'absolute',
                right: 0,
            }}
        >
            {!!dimensions && <Tag>{dimensions}</Tag>}
            <CheckableTag
                checked={transparentMode}
                toggleFunction={onToggleTransparent}
            >
                transparent
            </CheckableTag>
            <Tag
                data-test-target="reset-camera-3d-viewer"
                onClick={onReset}
                style={TAG_STYLE}
            >
                {resetTagText}
            </Tag>
        </div>
    )
}

export default InfoBar
